<template>
  <div>
    <validation-component
      ref="cashFormRef"
      :validation-condition="cashCondition">
    </validation-component>
  </div>
</template>

<script>
import { REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import {
  queryPickUpBankNameByCountry, queryPickUpBankBranchInfo,
} from '@/views/transfer/api/contact';

export default {
  components: { ValidationComponent },
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    txnFields: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      cashCondition: [
        {
          key: 'pickUpBankName',
          name: 'message.contact.pickUpBank',
          type: 'select',
          options: [],
          defValue: '',
          rule: [],
          isShowStar: true,
          validator: this.validatePickUpBankName,
          changeValue: async (value) => {
            this.$refs.cashFormRef.setItemValue('pickUpBankBranchName', '');
            if (!value) {
              this.$refs.cashFormRef.setValidationSelectOptions('pickUpBankBranchName', []);
              return;
            }
            // 获取分支机构
            this.$refs.cashFormRef.setItemLoading('pickUpBankBranchName', true);
            try {
              const res = await queryPickUpBankBranchInfo({ institutionName: value });
              this.bankBranchInfoList = res;
              const bankBranchList = [{
                value: 'title',
                label: this.$t('message.contact.bankBranchName'),
                disabled: true,
                type: 'title',
              }];
              const bankBranchMap = {};
              res.forEach(item => {
                const branchName = item.branchName;
                const branchAddress = item.branchAddress;
                if (!bankBranchMap[branchName]) {
                  bankBranchMap[branchName] = {
                    value: branchName,
                    label: branchName,
                    children: [],
                  };
                }
                if (branchAddress) {
                  bankBranchMap[branchName].children.push({
                    value: branchAddress,
                    label: branchAddress,
                  });
                }
              });

              Object.keys(bankBranchMap).forEach(k => {
                const item = bankBranchMap[k];
                const obj = {
                  value: item.value,
                  label: item.label,
                };
                if (item.children && item.children.length > 0) {
                  obj.children = item.children;
                  obj.children.unshift({
                    value: 'subtitle',
                    label: this.$t('message.contact.bankBranchAddress'),
                    disabled: true,
                    type: 'title',
                  });
                }
                bankBranchList.push(obj);
              });
              this.$refs.cashFormRef.setValidationSelectOptions('pickUpBankBranchName', bankBranchList);
            } catch (err) {
              //
            }
            this.$refs.cashFormRef.setItemLoading('pickUpBankBranchName', false);
          },
        },
        {
          key: 'pickUpBankBranchName',
          name: 'message.contact.branchName',
          type: 'cascader',
          defValue: '',
          options: [],
          rule: [],
          isShowStar: true,
          validator: this.validatePickUpBankBranchName,
        },
      ],
      bankBranchInfoList: [],
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      const cashForm = this.$refs.cashFormRef;

      const bankCountry = this.contact.bankCountry;

      let showPickUpBankBranchName = false;
      for (let i = 0; i < this.txnFields.length; i++) {
        const key = this.txnFields[i].key;
        const field = this.txnFields[i].field;
        if (['pickUpBankBranchName', 'pickUpBankName'].includes(key)) { // 现金支取
          if (key === 'pickUpBankBranchName') {
            showPickUpBankBranchName = field !== 'N';
            cashForm.setItemHide('pickUpBankBranchName', field === 'N');
            cashForm.setItemRequire('pickUpBankBranchName', field === 'Y');
            cashForm.setItemHide('pickUpBankName', field === 'N');
            cashForm.setItemRequire('pickUpBankName', field === 'Y');
          } else if (key === 'pickUpBankAddress' && !showPickUpBankBranchName) {
            cashForm.setItemHide('pickUpBankBranchName', field === 'N');
            cashForm.setItemRequire('pickUpBankBranchName', field === 'Y');
            cashForm.setItemHide('pickUpBankName', field === 'N');
            cashForm.setItemRequire('pickUpBankName', field === 'Y');
          }
        }
      }

      const res = await queryPickUpBankNameByCountry({ country: bankCountry });
      const options = res.map(item => ({
        value: item,
        label: item,
      }));
      cashForm.setValidationSelectOptions('pickUpBankName', options);
      let pickUpBankName = '';
      let pickUpBankBranchName = '';
      for (let i = 0; i < options.length; i++) {
        // 过滤不存在值的数据
        if (options[i].value === this.contact.pickUpBankName) {
          pickUpBankName = this.contact.pickUpBankName;
          break;
        }
      }

      if (pickUpBankName) {
        try {
          const res = await queryPickUpBankBranchInfo({ institutionName: pickUpBankName });
          this.bankBranchInfoList = res;
          const bankBranchList = [{
            value: 'title',
            label: this.$t('message.contact.bankBranchName'),
            disabled: true,
            type: 'title',
          }];
          const bankBranchMap = {};
          res.forEach(item => {
            const branchName = item.branchName;
            const branchAddress = item.branchAddress;
            if (!bankBranchMap[branchName]) {
              bankBranchMap[branchName] = {
                value: branchName,
                label: branchName,
                children: [],
              };
            }
            if (branchAddress) {
              bankBranchMap[branchName].children.push({
                value: branchAddress,
                label: branchAddress,
              });
            }
          });

          Object.keys(bankBranchMap).forEach(k => {
            const item = bankBranchMap[k];
            const obj = {
              value: item.value,
              label: item.label,
            };
            if (item.children && item.children.length > 0) {
              obj.children = item.children;
              obj.children.unshift({
                value: 'subtitle',
                label: this.$t('message.contact.bankBranchAddress'),
                disabled: true,
                type: 'title',
              });
            }
            bankBranchList.push(obj);
          });
          cashForm.setValidationSelectOptions('pickUpBankBranchName', bankBranchList);

          if (this.contact.pickUpBankBranchId) {
            for (let i = 0; i < this.bankBranchInfoList.length; i++) {
              const bankBranch = this.bankBranchInfoList[i];
              if (bankBranch.branchId === this.contact.pickUpBankBranchId) {
                pickUpBankBranchName = bankBranch.branchName + (bankBranch.branchAddress ? `***${bankBranch.branchAddress}` : '');
                break;
              }
            }
          }
        } catch (err) {
          //
        }
      }

      cashForm.assignmentFormValue({
        ...this.contact,
        pickUpBankName,
        pickUpBankBranchName,
      });
    },
    validate() { // 静默校验避免出现错误提示
      const data = this.$refs.cashFormRef.getFormJson();
      for (let i = 0; i < this.cashCondition.length; i++) {
        const item = this.cashCondition[i];
        if (!item.isHide) {
          if (item.validator && !item.validator(null, data[item.key])) {
            return false;
          } else if (item.rule && item.rule.length && !data[item.key]) {
            return false;
          }
        }
      }
      return true;
    },
    async getValidateData() {
      const cashFormValid = await this.$refs.cashFormRef.validateAsync();
      if (!cashFormValid) {
        return null;
      }
      const data = this.$refs.cashFormRef.getFormJson();
      if (data.pickUpBankBranchName) {
        const branchInfo = data.pickUpBankBranchName.split('***');
        for (let i = 0; i < this.bankBranchInfoList.length; i++) {
          const bankBranch = this.bankBranchInfoList[i];
          if (bankBranch.branchName === branchInfo[0]) {
            data.pickUpBankBranchName = bankBranch.branchName;
            if (branchInfo[1] && bankBranch.branchAddress === branchInfo[1]) {
              data.pickUpBankBranchId = bankBranch.branchId;
              data.pickUpBankAddress = bankBranch.branchAddress;
              break;
            } else if (!branchInfo[1]) {
              data.pickUpBankBranchId = bankBranch.branchId;
              data.pickUpBankAddress = '';
              break;
            }
          }
        }
      }
      return data;
    },
    isFieldRequired(key) {
      let required = false;
      for (let i = 0; i < this.txnFields.length; i++) {
        if (this.txnFields[i].key === key) {
          required = this.txnFields[i].field === 'Y';
          break;
        }
      }
      return required;
    },
    validatePickUpBankName(rule, value, callback = () => {}) {
      if (this.isFieldRequired('pickUpBankName') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      callback();
      return true;
    },
    validatePickUpBankBranchName(rule, value, callback = () => {}) {
      if (this.isFieldRequired('pickUpBankBranchName') && (!value || REQUIRED.regExp.test(value))) {
        callback(new Error(this.$t('message.validator.required')));
        return false;
      }
      callback();
      return true;
    },
  },
};
</script>

<style lang="scss">
.rhcn-cascader-dropdown {
  .el-cascader-panel {
    min-width: 637px;
    .el-cascader-menu__list .el-cascader-node .el-cascader-node-content.label {
      max-width: 450px;
    }
  }
}
</style>
